import { render, staticRenderFns } from "./02drugGeneModel.vue?vue&type=template&id=6dd44f83&"
import script from "./02drugGeneModel.vue?vue&type=script&lang=js&"
export * from "./02drugGeneModel.vue?vue&type=script&lang=js&"
import style0 from "./02drugGeneModel.vue?vue&type=style&index=0&id=6dd44f83&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports